import { render } from "./CovidHeader.vue?vue&type=template&id=26bc1f63"
import script from "./CovidHeader.vue?vue&type=script&lang=js"
export * from "./CovidHeader.vue?vue&type=script&lang=js"

import "./CovidHeader.vue?vue&type=style&index=0&id=26bc1f63&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__